import Font from "google-fonts";
import R from "ramda";

export const copyToClipboard = event => {
  var t = event.target,
    inp = event.target.previousSibling;

  // is element selectable?
  if (inp && inp.select) {
    // select text
    inp.select();

    try {
      // copy text
      document.execCommand("copy");
      inp.blur();

      // copied animation
      t.classList.add("copied");
      setTimeout(function() {
        t.classList.remove("copied");
      }, 1500);
    } catch (err) {
      alert("please press Ctrl/Cmd+C to copy");
    }
  }
};

export const getAspectRatio = (url, cb) => {
  const image = new Image();
  image.addEventListener("load", e => {
    const ratio = image.width / image.height;
    cb(ratio);
  });
  image.src = url;
};

export const loadGoogleFonts = fonts => {
  Object.keys(fonts).length > 0 &&
    Font.add(
      fonts.reduce(
        (acc, f) => ({
          ...acc,
          [f]: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
        }),
        {}
      )
    );
};

export const orderList = l => R.sortBy(R.last, R.toPairs(l)).map(R.head);

export const mapPath = R.curry((path, f, obj) => R.assocPath(path, f(R.path(path, obj)), obj));

export const isDev = process.env.NODE_ENV !== "production";



// WEBPACK FOOTER //
// ./src/reusable/utils.js